import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const readMemberList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/user/list/admin`, {
    params: param,
  });
  return data;
};

const readAppExpertList = async () => {
  const { data } = await axios.get(`${baseUrl}/longlifeuser/expertList`);
  return data;
};

const readAppMemberList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/longlifeuser/list/admin`, {
    params: param,
  });
  return data;
};

const readLonglifeUserList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/longlifeuser/list`, {
    params: param,
  });
  return data;
};

const readLonglifeExpertList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/longlifeuser/expertList`, {
    params: param,
  });
  return data;
};

const readMemberPointHistoryList = async (userId) => {
  const { data } = await axios.get(
    `${baseUrl}/point/point/history/search?user_id=${userId}`,
  );
  return data;
};

const earnPointForMember = async (param) => {
  const { data } = await axios.post(`${baseUrl}/point/admin/earn`, param);
  return data;
};

const sendPushForLonglife = async (param) => {
  const { data } = await axios.post(`${baseUrl}/longlife/push/send`, param);
  return data;
};

/**
 * 당영앱 회원 약사 채널에 가입시키기
 * @param param
 * @param param.userIdList 회원 아이디 list
 * @param param.created_by plutus 사용자 아이디
 * @param param.channel_id 가입 채널 아이디
 * @returns {Promise<*>}
 * 1) 405: 수정하기 위한 데이터 부족
 * 2) 999: Plutus SuperAdmin 계정이 아님
 * 3) 997: 유효한 채널 아이디가 아님
 * 4) 418: 이미 채널에 가입한 계정임
 * 5) 407: 데이터 수정 실패
 */
const postUserChannelJoin = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/longlifeuser/join/channel/admin`,
    param,
  );
  return data;
};

/**
 * 선물하기 안내 CRM 수기 재발송
 * @param param
 * @param param.orderIdList 주문 아이디(userOrder)의 목록
 * @param param.created_by 사용자 아이디
 * @returns {Promise<*>}
 * orderDetailDTOList: 주문별 재발송 결과 목록
 * order_id, memeo(실패사유)
 * total_cnt
 * 1) 405: 재발송처리를 위한 param 데이터 부족
 * 2) 999: Plutus SuperAdmin권한을 가진 계정이 아님
 */
const postGiftCrmReSend = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/gift/resend/crm`,
    param,
  );
  return data;
};
const memberApi = {
  readMemberList,
  readAppExpertList,
  readAppMemberList,
  readLonglifeUserList,
  readLonglifeExpertList,
  readMemberPointHistoryList,
  earnPointForMember,
  sendPushForLonglife,
  postUserChannelJoin,
  postGiftCrmReSend,
};

export default memberApi;
